import { render, staticRenderFns } from "./group-buying.vue?vue&type=template&id=150788da&scoped=true&"
import script from "./group-buying.vue?vue&type=script&lang=js&"
export * from "./group-buying.vue?vue&type=script&lang=js&"
import style0 from "./group-buying.vue?vue&type=style&index=0&id=150788da&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150788da",
  null
  
)

export default component.exports